import http from "./_http";
import { resolve, Resolved } from "./_resolve";

export async function getAll(): Promise<Resolved> {
  return await resolve(http.get("/api/country/"));
}
